import { any, nullable, object, string } from "../../../types/_types";

import { Party } from "../../organizations/types/Party";

export const SessionAgreement = object({
	id: string(),
	ref: any(),
	name: nullable(string()),
	type: nullable(string()),
	part: nullable(string()),
	state: nullable(string()),
	status: nullable(string()),
	firstParty: nullable(Party),
	secondParty: nullable(Party),
});
